import { ColDef } from "ag-grid-community";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azNodePoolColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_node_pool"),

  { field: "resource.instances_count", headerName: "Nodes" },

  getResourceCreationTimeColumnDef("Launch Time"),

  tagsColumnDef,
];
